import { json as jsonLanguage } from "@codemirror/lang-json";
import { yaml as yamlLanguage } from "@codemirror/lang-yaml";
import { StreamLanguage } from "@codemirror/language";
import { properties } from "@codemirror/legacy-modes/mode/properties";
import { toml } from "@codemirror/legacy-modes/mode/toml";
import { EditorView, type Extension } from "@uiw/react-codemirror";
import { EDITOR_SURFACE } from "../../common/editor-theme";
import type { FormatId } from "./formats";

export function editorExtensions(format: FormatId): Extension[] {
  return EXTENSIONS[format];
}

export function replaceDoc(view: EditorView | null, text: string) {
  // Dispatched rather than fed back as a value, which keeps a converted document undoable like any other edit.
  view?.dispatch({ changes: { from: 0, to: view.state.doc.length, insert: text } });
}

// Out here so their identity never changes: a new array reconfigures the running editor.
const BASE = [EditorView.lineWrapping, ...EDITOR_SURFACE];

// One array per format, built once: the mode is part of the editor's configuration and not of its document. The two
// flat formats share the one mode, `.env` being the same `key=value` with `#` above it that Java writes.
const EXTENSIONS: { [id in FormatId]: Extension[] } = {
  yaml: [yamlLanguage(), EditorView.contentAttributes.of({ "aria-label": "YAML" }), ...BASE],
  json: [jsonLanguage(), EditorView.contentAttributes.of({ "aria-label": "JSON" }), ...BASE],
  toml: [StreamLanguage.define(toml), EditorView.contentAttributes.of({ "aria-label": "TOML" }), ...BASE],
  env: [StreamLanguage.define(properties), EditorView.contentAttributes.of({ "aria-label": "dotenv" }), ...BASE],
  properties: [
    StreamLanguage.define(properties),
    EditorView.contentAttributes.of({ "aria-label": "Java properties" }),
    ...BASE,
  ],
};
